export default __webpack_public_path__ + "static/Gender-d8c2c1826e0522451a882bf212cdfa07.mp3";